import angular from 'angular';

let EmailListController = function ($filter, $mdDialog, $scope, $state, Email, Toast) {
  let $ctrl = this;
  $ctrl.$scope = $scope;

  angular.extend($ctrl, {
    edit, orderList, showCreateDialog
  });

  activate();

  function activate() {
    $ctrl.resources = {
      count: 0,
      data: []
    };

    $ctrl.uiState = 'LOADING';

    $ctrl.promise;

    $ctrl.$scope.tableConfig = {
      page: 1,
      limit: 10,
      order: 'name ASC',
      like_search: '',
      like_search_fields: [
        'name'
      ]
    };

    $ctrl.$scope.$watch('tableConfig', () => {
      loadData()
    }, true);
  }

  function edit(event, email) {
    showCreateDialog(event, email);
  }

  function orderList(field) {
    var tableConfig = $ctrl.$scope.tableConfig;
    if (tableConfig.order) {
      var currentField = tableConfig.order.split(' ')[0];
      var currentOrder = tableConfig.order.split(' ')[1];

      if (currentField === field) {
        currentOrder = currentOrder === 'DESC' ? 'ASC' : 'DESC';
        tableConfig.order = currentField + ' ' + currentOrder;
      } else {
        tableConfig.order = field + ' ' + 'ASC';
      }
    } else {
      tableConfig.order = field + ' ' + ' ASC';
    }
  }

  function showCreateDialog(event, selectedEmail) {
    $ctrl.selectedEmail = selectedEmail;

    let title = selectedEmail ? '\'common-edit\'' : '\'common-new-masculine\'';

    let dialog = {
      controller: DialogController,
      targetEvent: event,
      template:
      '<md-dialog aria-label="List dialog">' +
      '  <form name="form" ng-cloak ng-submit="saveResource(email)">' +
      '  <md-dialog-content class="layout-padding layout-padding-email-config">'+
      '  <div class="md-dialog-content" >'+
      '    <h2>{{ ' + title + ' | translate }}</h2>'+
      '<br>' +
      '    <md-input-container class="md-block" flex>'+
      '      <label>{{ \'common-name\' | translate }}</label>'+
      '' +
      '      <input ng-model="email.name" required>'+
      '    </md-input-container>' +
      '    <md-input-container class="md-block" flex>'+
      '      <label>{{ \'common-email\' | translate }}</label>'+
      '' +
      '      <input ng-model="email.email" required>'+
      '    </md-input-container>' +
      '    </div>' +
      '    </md-dialog-content>' +
      '  <md-dialog-actions>',
      bindToController: true,
      parent: angular.element(document.body),
      clickOutsideToClose:true,
      fullscreen: false
    };

    dialog.template += '' +
    '    <md-button ng-click="cancel()">' +
    '      {{ \'common-cancel\' | translate }}' +
    '    </md-button>' +
    '' +
    '    <md-button type="submit"' +
    '               ng-disabled="!form.$valid" class="md-accent">' +
    '      {{ \'common-save-button-text\' | translate }}' +
    '    </md-button>' +
    '  </md-dialog-actions>' +
    '  </form>' +
    '</md-dialog>';

    $mdDialog.show(dialog)
          .then((email) => {
            if (selectedEmail) {
              email = angular.extend(selectedEmail, email);
            }

            save(email);
          }, () => {});
  }

  function DialogController($scope, $mdDialog) {
    "ngInject";

    $scope.email = angular.copy($ctrl.selectedEmail) || {};

    $scope.hide = function() {
      $mdDialog.hide();
    };

    $scope.cancel = function() {
      $mdDialog.cancel();
    };

    $scope.saveResource = function(email) {
      $mdDialog.hide(email);
    };
  }

  // Local functions
  function loadData() {
    angular.extend($ctrl.$scope.tableConfig, $state.params);

    $ctrl.promise = Email
      .load($ctrl.$scope.tableConfig)
      .then(response => {
        $ctrl.resources = response;
        $ctrl.uiState = response.data.length ? 'COMPLETE' : 'EMPTY';
        $ctrl.$scope.$apply();
      })
      .catch(err => {
        console.log('err:' ,  err);
        $ctrl.uiState = 'ERROR';
      });
  }

  function save(email) {
    $ctrl.promise = Email
      .save(email)
      .then(response => {
        loadData();
        Toast.success($filter('translate')('email-detail-save-success'));
      })
      .catch(err => {
        loadData();
        let defaultErrMsg = 'common-server-error';
        let fourONineMsg = 'email-detail-409-error';
        let message = err.status == 409 ? fourONineMsg : defaultErrMsg;
        Toast.error($filter('translate')(message));
        console.log('err:' ,  err);
      });
  }
}

EmailListController.$inject = ['$filter', '$mdDialog', '$scope', '$state', 'Email', 'Toast'];

export default EmailListController;



// WEBPACK FOOTER //
// ./client/app/components/email/email-list.controller.js